import styled from 'styled-components/macro'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'

export const BirthdayUnlimitedPromotionInfoWrapper = styled(Box)`
    ${Text}:not(button) {
        display: inline;
    }
    button {
        display: contents;
    }
    a:focus {
        color: ${({ theme }) => theme.colors.grayscale_400};
    }
`
